export const propertyTypes = [
  "Economy",
  "Midscale",
  "Upscale",
  "Luxury",
  "Boutique",
] as const;
